import {useMutation} from '@tanstack/react-query';

import {toastRequestError} from '_utils/axios';

import {routes} from '_api';
import {generateToken} from "_api/fetchers/queues";

export function useQueueDeskToken() {
    const mutationKey = [...routes.queues.token] as const;

    return useMutation({
        mutationKey,
        mutationFn: async () => {
            return generateToken(mutationKey, {});
        },

        onMutate: async d => {

        },
        onSuccess: async d => {
        },
        onError: err => {
            toastRequestError(err);
        },
    });
}
